// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' //如果没加这个element-ui将没有样式
import axios from 'axios';
import qs from "qs";
import store from './store'
import permission from "./permission.js"
import VueAreaLinkage from 'vue-area-linkage';
import VueLazyload from 'vue-lazyload'
import Meta from 'vue-meta';
import App from './App'
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
Vue.use(VueAreaLinkage)
Vue.use(Meta);
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;

Vue.use(VueLazyload, {

  loading:'assets/loading.gif',

})
 let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        // localStorage.setItem('isiphone',flag)
        sessionStorage.setItem('ismobile', flag ? 1 : 0)
  
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {App},
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js